<template>
  <div class="submitted" redesign>
    <!-- Header -->
    <NomineeProgressBar
      stepName="You've successfully submitted your stipend request."
      :programMonth="user.currentProgramMonth"
    />

    <div class="form-container submitted-form">
      <LoadSpinner v-if="loading" :color="`#${organizationDetails.darkBrandColor}`" />
      <template v-if="!loading">
        <div class="form-field card-shape">
          <div class="success-circle-check-icon">
            <img src="@/assets/icons/success-circle-check-icon.png" />
          </div>
          <h4 v-translate>Success!</h4>
          <p v-translate>Your stipend request has been submitted. You may review the details & status of your request on the &ldquo;My Activity&rdquo; page.</p>
        </div>

        <SubmitButton
          :onContinue="handleSubmit"
          :buttonText="$gettext('Back to Home')"
          :darkText="true"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import { LoadSpinner } from '@/components'
import NomineeProgressBar from '@/components/stepper/NomineeProgressBar'
import SubmitButton from '@/components/requests/SubmitButton'

import NomineesApi from '@/services/nominees'

export default {
  name: 'StipendSubmitted',
  components: {
    LoadSpinner,
    NomineeProgressBar,
    SubmitButton,
  },
  data() {
    return {
      loading: true,
    }
  },
  async mounted() {
    this.loading = false
  },
  methods: {
    handleSubmit() {
      return true
    },
  },
  computed: {
    ...mapState(['user', 'organizationDetails', 'organizationCssVars']),
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/mixins/responsive';

.submitted {
  display: flex;
  flex-direction: column;

  .submitted-form {
    @extend .constrain-tablet-and-up;

    @media (min-width: 1140px) {
      max-width: 1076px !important;
    }
  }
}
</style>
